module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings#3-10f526d74d63d3530a7245459ed03d93.svg";